export interface Flag {
  country?: string;
  height?: number;
  width?: number;
}

interface Flags {
  [key: string]: string;
}

const flags: Flags = {};
const context = require.context('flag-icon-css/flags/1x1', false, /\.svg$/, 'eager');
context
  .keys()
  .forEach((key) =>
    context(key).then(
      (flag: string) => (flags[key.slice(2).replace('.svg', '').toUpperCase()] = flag)
    )
  );

export default flags;
